module.exports = "/static/media/tripadvisor.96d9d56f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/tripadvisor.svg
// module id = 1493
// module chunks = 0